import React from 'react';
import PropTypes from 'prop-types';

import Prompt from './Prompt';

const OnboardingPrompt = ({ onWithLocationClick, onWithoutLocationClick }) => (
  <Prompt>
    <h1>{__('Find places to Fish & Boat in your area')}</h1>
    <p>{__('Press "Explore your location" to start exploring your current area. You may be prompted to allow sharing of your location to use this feature.')}</p>
    <button
      type="button"
      className="btn-submit btn-primary"
      onClick={onWithLocationClick}
    >
      {__('Explore your location')}
    </button>
    <button
      type="button"
      className="btn-submit btn-secondary"
      onClick={onWithoutLocationClick}
    >
      {__('Explore entire U.S.')}
    </button>
  </Prompt>
);

OnboardingPrompt.propTypes = {
  onWithLocationClick: PropTypes.func.isRequired,
  onWithoutLocationClick: PropTypes.func.isRequired,
};

export default OnboardingPrompt;
